import { render, staticRenderFns } from "./SummaryTable.vue?vue&type=template&id=3c9c9e6a&scoped=true"
import script from "./SummaryTable.vue?vue&type=script&lang=ts"
export * from "./SummaryTable.vue?vue&type=script&lang=ts"
import style0 from "./SummaryTable.vue?vue&type=style&index=0&id=3c9c9e6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c9c9e6a",
  null
  
)

export default component.exports